import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import Blockquote from '../../../components/Blockquote';
import Button from '../../../components/Button';
import DatePicker from '../../../components/DatePicker';
import GenericCard from '../../../components/GenericCards/GenericCards';
import Select from '../../../components/Select';
import {
  addOrRemoveDaysToGivenDate,
  DateFormats,
  formatDate,
} from '../../../utils/utils';
import FilterPopover from '../filterPopover';

const options = [
  { value: 'terminated', label: 'Terminated' },
  { value: 'medical-std', label: 'Medical/STD' },
  { value: 'original-hire-date', label: 'Original Hire Date' },
];

const tableData = [
  {
    date: formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -1),
      DateFormats.US
    ),
    status: 'Terminated',
  },

  {
    date: '07/04/2010',
    status: 'Medical/STD',
  },

  {
    date: '05/12/1998',
    status: 'Original Hire Date',
  },
];

const popOverBody = (
  <Row>
    <Col className={'col-12 mb-7'}>
      <h2 className={'h6 fw-normal'}>Filters</h2>
    </Col>
    <Col className={'col-12'}>
      <DatePicker
        placeholder={'Select a start date'}
        label={'Select Date Range'}
      />
    </Col>
    <Col className={'col-12 mt-7'}>
      <DatePicker placeholder={'Select an end date'} />
    </Col>
    <Col className={'col-12 mt-7'}>
      <Select label={'Select Status'} options={options} />
    </Col>
  </Row>
);

const EmploymentHistory = () => {
  return (
    <Col className={'px-0 col-12 col-lg-7'}>
      <Row className={'mt-5 mt-lg-10'}>
        <Col className={'col-12'}>
          <Blockquote
            children={
              <span className={'text-fs-6 fw-light text-dark-grey'}>
                This information is being used to calculate your pension
                benefits. If anything is incorrect please contact the call
                center at 1-800-888-8888
              </span>
            }
          />
        </Col>
      </Row>

      <Row className={'mt-10 mt-lg-11'}>
        <Col className={'col-4 col-lg-12 d-flex justify-content-end'}>
          <FilterPopover
            popoverBody={popOverBody}
            children={<Button leftIcon={light('filter')}>{'Filter'}</Button>}
          />
        </Col>
      </Row>

      <GenericCard className={'mt-10 mt-lg-11 p-7 p-lg-10'} variant={'white'}>
        <Container></Container>
        <Row className={'py-7 border-bottom-dark-gray mx-0'}>
          <Col className={'col-6'}>
            <span className={'text-fs-6'}>Date</span>
          </Col>
          <Col className={'col-6 text-end'}>
            <span className={'text-fs-6'}>Status</span>
          </Col>
        </Row>

        {tableData.map((data, idx) => {
          return (
            <Row
              key={idx}
              className={`py-7 ${
                idx !== tableData.length - 1 ? 'border-bottom border-info' : ''
              } mx-0`}
            >
              <Col className={'col-6'}>
                <span className={'text-fs-6 fw-light'}>{data.date}</span>
              </Col>
              <Col className={'col-6 text-end'}>
                <span className={'text-fs-6 fw-light'}>{data.status}</span>
              </Col>
            </Row>
          );
        })}
      </GenericCard>
    </Col>
  );
};

export default EmploymentHistory;
